import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import "./index.scss";

import Pagination from "../../../../components/ui/Pagination";
import NoDataFound from "../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../components/ui/SkeletonLoader";
import RadioButton from "../../../../components/ui/RadioButton";
import Button from "../../../../components/ui/Button";
import DropDown from "../../../../components/ui/DropDown";

import { searchIcon, filterIcon, cerInfoIcon } from "../../../../utils/icons";

import { useScanInfoContext } from "../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { geCERStats, getCERData, resetCERStatus, resetCERDataList } from "../../../../store/actions/thirdPartyRiskAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const statusOption = [    
    {
        label: "Passed",
        value: "passed"
    },
    {
        label: "Failed",
        value: "failed"
    },
    {
        label: "Warning",
        value: "warning"
    },
    {
        label: "All",
        value: "all"
    }
]


const CorporateEmailRisk = () => {

    const cerStatsResponse = useSelector((state) => state.thirdPartyRisk.cerStats);
    const cerDataListResponse = useSelector((state) => state.thirdPartyRisk?.cerDataList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const { domainId, scanId } = useScanInfoContext();

    const [activeTab, setActiveTab] = useState("dmarcChecklist");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [tableDataList, setTableDataList] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [statsDMRC, setStatsDMRC] = useState(null);
    const [statsSPF, setStatsSPF] = useState(null);
    const [statsDKIM, setStatsDKIM] = useState(null);
    const [statsBIMI, setStatsBIMI] = useState(null);

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const changeTab = (data) => {
        setActiveTab(data);
        setSearchValue("");
        setSearchQuery("");
        setCurrentPageSize(10);
        setCurrentPage(1);
        resetFilterValue();
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if (pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        let obj = {
            findings: newFindingsType,
            status: selectedStatus
        }
        setSelectedFilterValue(obj)
        setShowFilter(false);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("");
        setSelectedStatus("");
    }

    const fetchRecordData = useCallback(() => {
        setStatsLoading(true)
        let url = `&domain=${domainId}&scan_id=${scanId}`
        dispatch(geCERStats(url))
    }, [dispatch, domainId, scanId])

    const fetchCERdataList = useCallback(() => {
        setIsLoading(true)
        const params = `&page=${currentPage}&page_size=${currentPageSize}&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const status = selectedFilterValue.status && selectedFilterValue.status !== "all" ? `&status=${selectedFilterValue.status}` : "";
        let baseUrl = ""
        if (activeTab === "dmarcChecklist") {
            baseUrl = `${apiEndpoints?.scanInfo?.thirdPartyRisk?.corporateEmailRisk?.dmarcCheckList()}`;
        } else if (activeTab === "spfChecklist") {
            baseUrl = `${apiEndpoints?.scanInfo?.thirdPartyRisk?.corporateEmailRisk?.spfCheckList()}`;
        } else if (activeTab === "dkimChecklist") {
            baseUrl = `${apiEndpoints?.scanInfo?.thirdPartyRisk?.corporateEmailRisk?.dkimCheckList()}`;
        } else {
            baseUrl = `${apiEndpoints?.scanInfo?.thirdPartyRisk?.corporateEmailRisk?.bimiCheckList()}`;
        }
        const url = `${baseUrl}${params}${queryParams}${newFindings}${status}`;
        dispatch(getCERData(url))
    }, [activeTab, domainId, scanId, currentPage, currentPageSize, searchQuery, selectedFilterValue, dispatch])

    useEffect(() => {
        fetchCERdataList();
    }, [activeTab, fetchCERdataList]);

    useEffect(() => {
        if (domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            fetchRecordData();
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId
        }
    }, [domainId, scanId, fetchRecordData]);

    useEffect(() => {
        if (cerStatsResponse !== null) {

            const getMaxStatEntry = (statsObj) => {
                if (!statsObj) return { key: "", value: 0 };

                const maxValue = Math.max(...Object.values(statsObj));

                const priority = ["failed", "warning", "passed"];

                const maxKeys = Object.entries(statsObj)
                                .filter(([_, value]) => value === maxValue)
                                .map(([key]) => key);

                const selectedKey = priority.find(p => maxKeys.includes(p)) || maxKeys[0];

                return { key: selectedKey, value: maxValue };
            };
            
            const { dmarc, spf, dkim, bimi } = cerStatsResponse || {};

            setStatsDMRC(getMaxStatEntry(dmarc));
            setStatsSPF(getMaxStatEntry(spf));
            setStatsDKIM(getMaxStatEntry(dkim));
            setStatsBIMI(getMaxStatEntry(bimi));
        
            dispatch(resetCERStatus());
            setStatsLoading(false);
        }
    }, [cerStatsResponse, dispatch])

    useEffect(() => {
        if (cerDataListResponse !== null) {
            setTableDataList(cerDataListResponse)
            if (cerDataListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetCERDataList())
            setIsLoading(false)
        }
    }, [cerDataListResponse, dispatch])

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if (showFilter) {
                    setShowFilter(false)
                }
            }
        }
    }, [showFilter])

    return (
        <>
            <div className="scan-info-main-content CE-main-content">
                <div className="bg-white-with-shadow p-4">
                    <div className="header-container d-flex justify-content-between align-items-center">
                        <h2>Business Email Compromise(BEC)</h2>
                        {/* <p>Service Provider : <span>ProofPoint</span></p> */}
                    </div>
                    <Row>
                        <Col lg={3} className="mt-2">
                            <div className="bec-main-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                        <SkeletonLoader type={"line"} count={3} currentPage={"bec"} />
                                    :
                                    <motion.div
                                        className="h-100 d-flex flex-column justify-content-between"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div>
                                            <h4 className="dmarc-heading">
                                                DMARC
                                                {cerInfoIcon()}
                                            </h4>
                                            <p>Properly configured DMARC Policies can reduce email spoofing attacks by upto 90%, enhancing email security</p>
                                        </div>                                        
                                        <div className="d-flex flex-column align-items-start mt-3 w-100">
                                            <div className="d-flex justify-content-between w-100 mb-1">
                                                <span className={`${statsDMRC?.key === "passed" ? "percentage-text-green" : statsDMRC?.key === "failed" ? "percentage-text-red" : "percentage-text"}`}>{statsDMRC?.value}%</span>
                                                <span className={`text-capitalize ${statsDMRC?.key === "passed" ? "status-passed" : statsDMRC?.key === "failed" ? "status-failed" : "status-warning"}`}>
                                                    {statsDMRC?.key}
                                                </span>
                                            </div>
                                            <div className="custom-progress">
                                                <div
                                                    className={`custom-progress-bar ${statsDMRC?.key === "passed" ? "progress-passed" : statsDMRC?.key === "failed" ? "progress-failed" : "progress-medium"}`}
                                                    style={{ width: `${statsDMRC?.value}%` }}
                                                    role="progressbar"
                                                    aria-valuenow={statsDMRC?.value}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={3} className="mt-2">
                            <div className="bec-main-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                        <SkeletonLoader type={"line"} count={3} currentPage={"bec"} />
                                    :
                                    <motion.div
                                        className="h-100 d-flex flex-column justify-content-between"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div>
                                            <h4 className="dmarc-heading">SPF {cerInfoIcon()}</h4>
                                            <p>Configuring SPF blocks unauthorized senders, significantly reducing phishing risks by verifiying email success</p>
                                        </div>                                        
                                        <div className="d-flex flex-column align-items-start mt-3 w-100">
                                            <div className="d-flex justify-content-between w-100 mb-1">
                                                <span className={`${statsSPF?.key === "passed" ? "percentage-text-green" : statsSPF?.key === "failed" ? "percentage-text-red" : "percentage-text"}`}>{statsSPF?.value}%</span>
                                                <span className={`text-capitalize ${statsSPF?.key === "passed" ? "status-passed" : statsSPF?.key === "failed" ? "status-failed" : "status-warning"}`}>
                                                    {statsSPF?.key}
                                                </span>
                                            </div>
                                            <div className="custom-progress">
                                                <div
                                                    className={`custom-progress-bar ${statsSPF?.key === "passed" ? "progress-passed" : statsSPF?.key === "failed" ? "progress-failed" : "progress-medium"}`}
                                                    style={{ width: `${statsSPF?.value}%` }}
                                                    role="progressbar"
                                                    aria-valuenow={statsSPF?.value}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={3} className="mt-2">
                            <div className="bec-main-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                        <SkeletonLoader type={"line"} count={3} currentPage={"bec"} />
                                    :
                                    <motion.div
                                        className="h-100 d-flex flex-column justify-content-between"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div>
                                            <h4 className="dmarc-heading">DKIM {cerInfoIcon()}</h4>
                                            <p>Accurate DKIM settings improve deliverability by 20%, helping prevent legitimate emails from being marked as spam.</p>
                                        </div>                                        
                                        <div className="d-flex flex-column align-items-start mt-3 w-100">
                                            <div className="d-flex justify-content-between w-100 mb-1">
                                                <span className={`${statsDKIM?.key === "passed" ? "percentage-text-green" : statsDKIM?.key === "failed" ? "percentage-text-red" : "percentage-text"}`}>{statsDKIM?.value}%</span>
                                                <span className={`text-capitalize ${statsDKIM?.key === "passed" ? "status-passed" : statsDKIM?.key === "failed" ? "status-failed" : "status-warning"}`}>
                                                    {statsDKIM?.key}
                                                </span>
                                            </div>
                                            <div className="custom-progress">
                                                <div
                                                    className={`custom-progress-bar ${statsDKIM?.key === "passed" ? "progress-passed" : statsDKIM?.key === "failed" ? "progress-failed" : "progress-medium"}`}
                                                    style={{ width: `${statsDKIM?.value}%` }}
                                                    role="progressbar"
                                                    aria-valuenow={statsDKIM?.value}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={3} className="mt-2">
                            <div className="bec-main-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                        <SkeletonLoader type={"line"} count={3} currentPage={"bec"} />
                                    :
                                    <motion.div
                                        className="h-100 d-flex flex-column justify-content-between"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div>
                                            <h4 className="dmarc-heading">BIMI {cerInfoIcon()}</h4>
                                            <p>Correct BIMI setup boosts brand visibility in inboxes by 10% reinforcing recipient trust.</p>
                                        </div>                                        
                                        <div className="d-flex flex-column align-items-start mt-3 w-100">
                                            <div className="d-flex justify-content-between w-100 mb-1">
                                                <span className={`${statsBIMI?.key === "passed" ? "percentage-text-green" : statsBIMI?.key === "failed" ? "percentage-text-red" : "percentage-text"}`}>{statsBIMI?.value}%</span>
                                                <span className={`text-capitalize ${statsBIMI?.key === "passed" ? "status-passed" : statsBIMI?.key === "failed" ? "status-failed" : "status-warning"}`}>
                                                    {statsBIMI?.key}
                                                </span>
                                            </div>
                                            <div className="custom-progress">
                                                <div
                                                    className={`custom-progress-bar ${statsBIMI?.key === "passed" ? "progress-passed" : statsBIMI?.key === "failed" ? "progress-failed" : "progress-medium"}`}
                                                    style={{ width: `${statsBIMI?.value}%` }}
                                                    role="progressbar"
                                                    aria-valuenow={statsBIMI?.value}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={12}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="tab-container d-flex rounded">
                                    <p className={`rounded text-center ${activeTab === "dmarcChecklist" ? "active" : ""}`} onClick={() => { changeTab('dmarcChecklist') }}>DMARC Checklist</p>
                                    <p className={`rounded text-center ${activeTab === "spfChecklist" ? "active" : ""}`} onClick={() => { changeTab('spfChecklist') }}>SPF Checklist</p>
                                    <p className={`rounded text-center ${activeTab === "dkimChecklist" ? "active" : ""}`} onClick={() => { changeTab('dkimChecklist') }}>DKIM Checklist</p>
                                    <p className={`rounded text-center ${activeTab === "bimiChecklist" ? "active" : ""}`} onClick={() => { changeTab('bimiChecklist') }}>BIMI Checklist</p>
                                </div>
                                <div className="tab-details-content mt-3 tab-content-CER">
                                    <div className="search-header-container d-flex align-items-center gap-3">
                                        <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                            <div className="search-container position-relative">
                                                <span className="position-absolute">{searchIcon()}</span>
                                                <input type="text" 
                                                    placeholder="Search" 
                                                    value={searchValue} 
                                                    onChange={(e)=>{
                                                        setSearchValue(e.target.value)
                                                    }}
                                                    onFocus={() => setIsSearchFocused(true)}
                                                    onBlur={() => setIsSearchFocused(false)}
                                                />
                                            </div>
                                            <button className="search-btn" onClick={onSearch}>Search</button>
                                        </div>
                                        <div className="position-relative">
                                            <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>                        
                                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                                <h6>New Findings</h6>
                                                <div className="filter-user-status d-flex mb-4 gap-4">
                                                    {
                                                        newFindingsOption.map((data,index)=>{
                                                            return (
                                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <h6>Status</h6>
                                                <DropDown 
                                                    placeHolder={"Status"}
                                                    options={statusOption}
                                                    isMulti={false}
                                                    isSearchable={false}
                                                    onChange={(data)=>{setSelectedStatus(data.value)}}
                                                    defaultSelectedValue={selectedStatus}
                                                />
                                                <div className="filter-apply-btn mt-3">
                                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && selectedStatus === ""} buttonClicked={()=>{applyFilter()}}/>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="table-container mt-3 cer-data-table">
                                        {
                                            isLoading && !scanNotFound ?
                                            <SkeletonLoader type={"line"} count={5} currentPage={"CER"} />
                                            :
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Info</th>
                                                        <th>Status</th>
                                                        <th>Record</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableDataList?.results?.length > 0 &&
                                                        tableDataList?.results?.map((data, index) => {
                                                            return (
                                                                <motion.tr
                                                                    key={index}
                                                                    initial={{ opacity: 0, y: 20 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                                >
                                                                    <td>
                                                                        <p>{data?.name}</p>
                                                                        {data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                                    </td>
                                                                    <td>
                                                                        {data?.info}
                                                                    </td>
                                                                    <td>
                                                                        {data?.status === "passed" && <p className="passed text-center">{data?.status}</p>}
                                                                        {data?.status === "warning" && <p className="warning text-center">{data?.status}</p>}
                                                                        {data?.status === "failed" && <p className="failed text-center">{data?.status}</p>}
                                                                    </td>
                                                                    <td>
                                                                        <p className="work-break">{data?.record}</p>
                                                                    </td>
                                                                </motion.tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                        }
                                        
                                    </div>
                                    {
                                        !isLoading && scanNotFound &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={tableDataList?.description}/>
                                        </motion.div>
                                    }
                                    {
                                        !isLoading && !scanNotFound && tableDataList !== "" && tableDataList?.results?.length === 0 && 
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Record Found"}/>
                                        </motion.div>
                                    }
                                    {tableDataList !== "" && tableDataList?.results?.length > 0 && <Pagination
                                        className="pagination-bar"
                                        currentPage={currentPage}
                                        pageSize={currentPageSize}
                                        totalCount={tableDataList?.meta?.total_results}
                                        onPageChange={setCurrentPageandRecordSize}
                                    />}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>

    )
}


export default CorporateEmailRisk;